import { all, fork } from "redux-saga/effects"
import userProfileSaga from "./user-profile/saga"
import userBalanceSaga from "./user-balance/saga"

//public


export default function* rootSaga() {
  yield all([
    //public
    fork(userProfileSaga),
    fork(userBalanceSaga),
  ])
}
